import { createSlice } from '@reduxjs/toolkit';
import { resetStore } from '../../Actions';
import { setIsLoading } from '../Loader/LoaderSlice';
import { setApiError } from '../Error/ErrorSlice';
import { fireApi } from '../../../utils/FireApi';
// import { fireApi } from 'src/utils/FireApi';
import { CallCenterApi, LeadApi } from '../../../utils/Apis';

const initialState = {
  lead_grid: null,
  lead_view: null,
  lead_list: null,
  app_data: null,
  assign_status: null,
  branchBankId: null
};

const LeadSlice = createSlice({
  name: 'Lead',
  initialState,
  reducers: {
    setLeadGrid(state, action) {
      state.lead_grid = action.payload;
    },
    setLeadView(state, action) {
      state.lead_view = action.payload;
    },
    setLeadList(state, action) {
      state.lead_list = action.payload;
    },
    setAppById(state, action) {
      state.app_data = action.payload;
    },
    setAssignStatus(state, action) {
      state.assign_status = action.payload;
    },
    setBranchBankId(state, action) {
      state.branchBankId = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetStore, () => initialState); // clear store
  }
});

// Lead Grid
export const getLeadGridData = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: LeadApi?.leadList,
      method: 'post',
      payload: data
    });
    // console.log('sss lead grid res', res);
    // 🔹 Handle success
    if (res?.success) {
      dispatch(setLeadGrid(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setLeadGrid(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Lead Grid failed ', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Lead Grid exception ', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Lead View
export const getLeadViewData = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: LeadApi?.leadView,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setLeadView(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setLeadView(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Lead View failed ', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Lead View exception ', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Lead List Status
export const getLeadListStatus = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: LeadApi?.leadListStatus,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setLeadList(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setLeadList(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Lead List Status failed ', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Lead List Status exception ', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Lead List Status
export const getRecoEngineApi =
  ({ userId }) =>
  async (dispatch) => {
    dispatch(setIsLoading({ loading: true }));
    try {
      const res = await fireApi({
        endpoint: `${LeadApi.recoEngineApi}${userId}`, // ✅ userId in URL
        method: 'get'
      });
      // console.log('sss reco res', res);
      // 🔹 Handle success
      if (res?.success) {
        return res?.data;
      } else {
        dispatch(setLeadList(null)); // store in redux
        dispatch(setApiError(res?.message || 'Something went wrong'));
        console.error('❌ reco engine api failed ', res?.data?.error);
        return null;
      }
    } catch (error) {
      dispatch(setApiError('Something went wrong'));
      console.error('🔥 reco engine api ', error);
      return null;
    } finally {
      dispatch(setIsLoading({ loading: false }));
    }
  };

// Lead Add Comment
export const getLeadAddComment = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: LeadApi?.leadAddComment,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      return res?.data;
    } else {
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Lead Add Comment failed ', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Lead Add Comment exception ', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Lead Add Remainder
export const getLeadAddRemainder = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: LeadApi?.createRemainder,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      return res?.data;
    } else {
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Lead Add Remainder failed ', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Lead Add Remainder exception ', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Lead Assign Status
export const getLeadAssignStatus = (id) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: LeadApi?.assignStatus(id)
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setAssignStatus(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setAssignStatus(null)); // store in redux

      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Lead Assign Status failed ', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Lead Assign Status exception ', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// // Lead Status Update
// export const getLeadStatusUpdate = (data) => async (dispatch) => {
//   dispatch(setIsLoading({ loading: true }));
//   try {
//     const res = await fireApi({
//       endpoint: LeadApi?.statusUpdate,
//       method: 'post',
//       payload: data
//     });

//     // 🔹 Handle success
//     if (res?.success) {
//       return res?.data;
//     } else {
//       dispatch(setApiError(res?.message || 'Something went wrong'));
//       console.error('❌ Lead Status Update failed ', res?.data?.error);
//       return null;
//     }
//   } catch (error) {
//     dispatch(setApiError('Something went wrong'));
//     console.error('🔥 Lead Status Update exception ', error);
//     return null;
//   } finally {
//     dispatch(setIsLoading({ loading: false }));
//   }
// };

// offline Application Response get application by id
export const getOfflineApplicationRes = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: LeadApi?.offlineApplicationRes,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setAppById(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      // dispatch(setAppById(null)); // store in redux
      // dispatch(setApiError(res?.message || 'Something went wrong'));
      // console.error('❌ offline Application Response failed ', res?.data?.error);
      // return null;
      let errorMsg = 'Something went wrong';
      if (
        res?.data?.error?.includes("required property 'application-id' is missing") ||
        res?.data?.error?.includes('Unable to find loan-application')
      ) {
        errorMsg = 'Loan application summary not found for the selected Lead';
      } else if (res?.message) {
        errorMsg = res.message;
      }

      dispatch(setAppById(null)); // clear previous data
      dispatch(setApiError(errorMsg));
      console.error('❌ offline Application Response failed', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 offline Application Response exception ', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

export const getBranchRecordByBank =
  ({ bankId }) =>
  async (dispatch) => {
    dispatch(setIsLoading({ loading: true }));
    try {
      const res = await fireApi({
        endpoint: `${LeadApi?.branchByBankApi}/${bankId}`,
        method: 'get'
      });
      // console.log('sss res for branch', res?.data?.data?.branches);
      // 🔹 Handle success
      // 🔹 Handle success
      if (res?.success) {
        dispatch(setBranchBankId(res?.data?.data ? res?.data?.data?.branches : res?.data)); // store in redux
        return res?.data;
      } else {
        dispatch(setBranchBankId(null)); // store in redux

        dispatch(setApiError(res?.message || 'Something went wrong'));
        console.error('❌ Lead Assign Status failed ', res?.data?.error);
        return null;
      }
    } catch (error) {
      dispatch(setApiError('Something went wrong'));
      console.error('🔥 Lead Assign Status exception ', error);
      return null;
    } finally {
      dispatch(setIsLoading({ loading: false }));
    }
  };

export const {
  setLeadGrid,
  setLeadView,
  setLeadList,
  setAppById,
  setAssignStatus,
  setBranchBankId
} = LeadSlice.actions;
export default LeadSlice.reducer;
